// ConstantsPhysicsCalculator.js
export const physicsCalculators = [
  {
    name: "Kalkulator Waktu Tempuh",
    link: "/calculator/id/arrivaltime/",
    description:
      "Kalkulator waktu tempuh menghitung waktu kedatangan seseorang, mobil, atau benda bergerak berdasarkan kecepatan dan jarak.",
    showMain: true,
  },
  {
    name: "Kalkulator Meter Kubik",
    link: "/calculator/id/cubicmeter/",
    description:
      "Kalkulator ini menghitung meter kubik - kalkulator meter kubik elektronik - pelajari cara menghitung meter kubik",
    showMain: true,
  },
  {
    name: "Kalkulator Kekuatan Lensa Mata",
    link: "/calculator/id/lenspower/",
    description:
      "Kalkulator kekuatan lensa elektronik menghitung lensa mata dan kekuatan optiknya dengan sangat akurat dan cepat",
  },
  {
    name: "Kalkulator Muatan Listrik",
    link: "/calculator/id/electric-charge/",
    description:
      "Kalkulator muatan listrik menghitung nilai muatan listrik berdasarkan gaya interaksi antara dua benda bermuatan.",
    showMain: true,
  },
  {
    name: "Kalkulator Kecepatan - Cara Menghitung Kecepatan",
    link: "/calculator/id/velocity/",
    description: "Kalkulator kecepatan menghitung kecepatan berdasarkan jarak dan waktu",
    showMain: true,
  },
  {
    name: "Kalkulator Percepatan - Cara Menghitung Percepatan",
    link: "/calculator/id/acceleration/",
    description:
      "Kalkulator percepatan menghitung percepatan berdasarkan perubahan kecepatan dan waktu.",
  },
  {
    name: "Kalkulator Energi Foton",
    link: "/calculator/id/photonenergy/",
    description:
      "Kalkulator energi foton menghitung energi foton berdasarkan frekuensi foton dan konstanta Planck.",
  },
  {
    name: "Kalkulator Gaya Gesek",
    link: "/calculator/id/frictionforce/",
    description:
      "Kalkulator gaya gesek menghitung gaya gesek berdasarkan percepatan dan massa.",
  },
  {
    name: "Kalkulator Tenaga Mesin Mobil",
    link: "/calculator/id/horsepower/",
    description:
      "Kalkulator tenaga mesin mobil memperkirakan tenaga kuda mesin mobil berdasarkan berat mobil, waktu yang berlalu, dan kecepatan yang digunakan untuk menyelesaikan jarak seperempat mil.",
  },
  {
    name: "Kalkulator Energi Kinetik",
    link: "/calculator/id/kineticenergy/",
    description:
      "Kalkulator energi kinetik menghitung energi gerak suatu benda berdasarkan massa dan kecepatan.",
  },
  {
    name: "Kalkulator Energi Potensial",
    link: "/calculator/id/potentialenergy/",
    description:
      "Kalkulator energi potensial komprehensif: Hitung energi potensial, massa, atau ketinggian berdasarkan nilai input massa, ketinggian, atau energi potensial. Alat yang akurat dan mudah digunakan.",
  },
  {
    name: "Kalkulator Energi Listrik",
    link: "/calculator/id/electricalenergy/",
    description:
      "Kalkulator energi listrik komprehensif: Hitung energi listrik, daya, atau waktu berdasarkan nilai input daya, waktu, atau energi listrik. Alat yang akurat dan mudah digunakan.",
    showMain: true,
  },
  {
    name: "Kalkulator Hukum Ohm",
    link: "/calculator/id/ohmslaw/",
    description:
      "Kalkulator Hukum Ohm komprehensif: Hitung tegangan, arus, atau resistansi menggunakan nilai input tegangan, arus, atau resistansi. Alat yang akurat dan mudah digunakan.",
    showMain: true,
  },
  {
    name: "Kalkulator Gelombang",
    link: "/calculator/id/wave/",
    description:
      "Kalkulator gelombang komprehensif: Hitung panjang gelombang, frekuensi, atau kecepatan gelombang menggunakan nilai input. Alat yang akurat dan mudah digunakan.",
    showMain: true,
  },
  {
    name: "Kalkulator Tekanan",
    link: "/calculator/id/pressure/",
    description:
      "Kalkulator tekanan komprehensif: Hitung tekanan, gaya, atau luas menggunakan nilai input. Alat yang akurat dan mudah digunakan.",
  },
  {
    name: "Kalkulator Resistansi",
    link: "/calculator/id/resistor-calculator/",
    description:
      "Kalkulator ini membantu Anda mengetahui nilai resistansi berdasarkan warnanya.",
  },
  {
    name: "Kalkulator Massa Bumi",
    link: "/calculator/id/earth-mass-calculator/",
    description: "Hitung massa Bumi menggunakan hukum gravitasi universal.",
  },
  {
    name: "Memilih Jumlah Panel Surya, Baterai, dan Inverter yang Tepat",
    link: "/calculator/id/solar-calculator/",
    description:
      "Hitung sistem energi surya Anda untuk rumah menggunakan kalkulator ini.",
  },
  {
    name: "Kalkulator Massa Jenis Air",
    link: "/calculator/id/water-density-calculator/",
    description:
      "Gunakan kalkulator massa jenis air untuk menghitung massa jenis air atau zat lain dengan mudah menggunakan persamaan: massa jenis = massa zat / volume zat. Pelajari cara mengonversi satuan massa jenis dan memahami konsep massa jenis.",
  },
  {
    name: "Kalkulator Kapasitas Transformator",
    link: "/calculator/id/transformer-capacity-calculator/",
    description:
      "Gunakan kalkulator kapasitas transformator untuk menghitung kapasitas transformator listrik untuk fasilitas apa pun dengan mudah dan akurat. Masukkan tegangan dan kuat arus untuk mendapatkan kapasitas yang diperlukan menggunakan rumus yang sesuai.",
  },
];
export default physicsCalculators;